import { Helmet } from 'react-helmet-async';

import { Content } from './components/Content';

export const AdminOrganizationsListPage = () => {
  return (
    <>
      <Helmet>
        <title>Organizations - AutoScript Admin</title>
      </Helmet>

      <Content />
    </>
  );
};
